import { useEffect } from 'react'
import { Typography } from '@mui/material'
import { ContactInformationContainer, InfoContainer } from '../components/exports/company-info-styles.export'
import { useStateContext } from '../context/StateContextAPI'
import useGoogleTag from '../utils/gtag'

const sectionHeadingSx = {
    color: 'var(--primary)',
    margin: '10px 0',
    fontSize: '18px',
    fontWeight: '600'
}

const CareersPage = () => {
    const gtag = process.env.REACT_APP_GOOGLE_TAG || ""
    useGoogleTag(gtag)

    const { setActivePage } = useStateContext()

    useEffect(() => {
        setActivePage(() => "")
        window.scrollTo(0, 0)
    }, [setActivePage])

    return (
        <ContactInformationContainer>
            <div className='rokk-users-faq-sec'>
                <div className="faq-section-head-text" style={{ marginTop: '40px', marginBottom: '10px' }}>BUSINESS DEVELOPMENT / SALES MANAGER (M/W/D)</div>

                <InfoContainer>
                    <Typography sx={sectionHeadingSx}>
                        ROKK Streaming – Fairer Musik-Streaming-Service
                    </Typography>
                    <Typography>
                        ROKK Streaming steht für eine neue Generation von Musik-Streaming:
                        ehrlich, fair und klar auf echte Künstler fokussiert. Keine KI-generierte Massenware. Ein transparentes Modell. Eine Plattform, auf der Musik wieder im Mittelpunkt steht – und Menschen hinter der Musik sichtbar bleiben. ROKK ist kein gewöhnlicher Streaming-Dienst. Wir bauen ein Ökosystem für Künstler, Fans und Labels, das auf Fairness, Transparenz und echter Leidenschaft für Musik basiert. Zur Unterstützung unseres Wachstums suchen wir eine engagierte Persönlichkeit im Bereich Business Development und Artist Partnerships.
                    </Typography>

                    <Typography sx={sectionHeadingSx}>
                        Deine Aufgaben
                    </Typography>
                    <Typography component="ul" sx={{ paddingLeft: '25px', listStyle: 'disc' }}>
                        <li>Gewinnung neuer Nutzer für ROKK durch Kooperationen mit Künstlern, Labels, Medien und Communities</li>
                        <li>Aufbau und Pflege von Partnerschaften mit Künstlern, Labels und Managements</li>
                        <li>Entwicklung von Kooperationen und Kampagnen, die neue Nutzer zur Plattform bringen</li>
                        <li>Akquise neuer Partner im Musik-Ökosystem</li>
                        <li>Networking mit Künstlern, Labels und Branchenkontakten</li>
                        <li>Identifikation neuer Wachstums- und Vertriebsmöglichkeiten für die Plattform</li>
                        <li>Mitgestaltung der strategischen Weiterentwicklung von ROKK</li>
                        <li>Repräsentation von ROKK gegenüber Partnern und in der Musikbranche</li>
                    </Typography>

                    <Typography sx={sectionHeadingSx}>
                        Dein Profil
                    </Typography>
                    <Typography component="ul" sx={{ paddingLeft: '25px', listStyle: 'disc' }}>
                        <li>Erfahrung im Bereich Sales, Business Development oder Partnerships</li>
                        <li>Interesse an der Musikbranche und digitalen Plattformen</li>
                        <li>Kommunikationsstärke und Verhandlungsgeschick</li>
                        <li>Eigenständige, strukturierte Arbeitsweise</li>
                        <li>Unternehmerisches Denken und Initiative</li>
                        <li>Sehr gute Deutschkenntnisse, Englisch von Vorteil</li>
                    </Typography>

                    <Typography sx={sectionHeadingSx}>
                        Wir bieten
                    </Typography>
                    <Typography component="ul" sx={{ paddingLeft: '25px', listStyle: 'disc' }}>
                        <li>Remote-Arbeit / Home Office möglich</li>
                        <li>Arbeit in einem ambitionierten Startup im Musikbereich</li>
                        <li>Hohe Gestaltungsmöglichkeiten und direkte Verantwortung</li>
                        <li>Zusammenarbeit mit einem kleinen, engagierten Team</li>
                        <li>Ein Projekt mit klarer Mission: Musikstreaming fairer zu machen</li>
                    </Typography>

                    <Typography sx={sectionHeadingSx}>
                        Bewerbung
                    </Typography>
                    <Typography>
                        Wenn du Interesse hast, Teil von ROKK zu werden und die Zukunft eines faireren Musik-Streamings mitzugestalten, freuen wir uns auf deine Bewerbung.
                    </Typography>
                    <Typography sx={{ marginTop: '10px' }}>
                        Bitte sende deinen Lebenslauf oder ein kurzes Profil an:{' '}
                        <a href="mailto:peter@rokk.app">peter@rokk.app</a>
                    </Typography>

                    <Typography sx={sectionHeadingSx}>
                        Über ROKK
                    </Typography>
                    <Typography>
                        ROKK ist ein unabhängiger Musik-Streaming-Service mit Fokus auf Transparenz und fairer Vergütung von Künstlern.
                    </Typography>
                    <Typography>
                        Unsere Plattform richtet sich an echte Musikfans und unterstützt Künstler direkt.
                    </Typography>
                    <Typography sx={{ marginTop: '10px' }}>
                        Mehr über ROKK:{' '}
                        <a href="/">rokk.app</a>
                    </Typography>
                </InfoContainer>
            </div>
        </ContactInformationContainer>
    )
}

export default CareersPage
